import { Component, Inject } from '@angular/core';

import { DesignStepService
       } from 'collage-designer/design-step/design-step.service';
import { ProductUpgradeService
       } from 'core/product-upgrade/product-upgrade.service';
import { Utils } from 'core/utils';
import { ToolboxComponent, } from '../toolbox.component';
import { ToolboxService, } from '../toolbox.service';

@Component({
    selector: 'layout-toolbox',
    templateUrl: './layout-toolbox.component.html',
    styleUrls: ['../toolbox.component.scss'],
    standalone: false
})
export class LayoutToolboxComponent extends ToolboxComponent
{
  protected name: string = 'LayoutToolbox';

  private designStepService: DesignStepService;

  constructor(
      @Inject(DesignStepService) designStepService,
      @Inject(ProductUpgradeService) private productUpgradeService:
          ProductUpgradeService,
      @Inject(ToolboxService) toolboxService
  )
  {
    super(toolboxService);
    this.designStepService = designStepService;
  }

  public get isBoxStep(): boolean
  {
    return this.designStepService.isBoxStep();
  }

  public async updateSelectedTemplate(
      templateGroupId: string, templateId: string): Promise<void>
  {
    await this.designStepService.setTemplateGroupId(
        templateGroupId, templateId);
    this.closeIfSmallOrMediumDevice();

    await this.productUpgradeService.popUpgradeDialogIfPossible(
        templateGroupId, templateId);
  }

  public closeIfSmallOrMediumDevice(): void
  {
    if (!Utils.isLargeDevice()) {
      this.btnCloseClick();
    }
  }
}
